import { Component, Host, Prop, h } from "@stencil/core";

@Component({
    tag: "ux-iws-notification-bar",
    styleUrl: "notification-bar.scss",
})
export class TeaserNotification {
    private baseClass = "ux-iws-notification-bar";

    /** the name of the icon to be rendered */
    @Prop() iconName: string = "info";
    /** sets the background of the element, default is grey */
    @Prop() background: "grey" | "green" | "blue" | "white" = "grey";

    render() {
        const WrapperElement =
            this.background === "white" ? "div" : "ux-iws-link-wrapper";

        return (
            <Host class={this.baseClass}>
                <WrapperElement
                    class={{
                        [`${this.baseClass}__wrapper`]: true,
                        [`${this.baseClass}__wrapper--blue`]:
                            this.background === "blue",
                        [`${this.baseClass}__wrapper--green`]:
                            this.background === "green",
                        [`${this.baseClass}__wrapper--white`]:
                            this.background === "white",
                    }}
                >
                    <div class="ux-t-container">
                        <div class="ux-row">
                            <div class="ux-col-12 ux-col-md-10 ux-u-offset-md-1">
                                <div class={`${this.baseClass}__inner-wrapper`}>
                                    <div class={`${this.baseClass}__icon`}>
                                        <ux-icon name={this.iconName}></ux-icon>
                                    </div>
                                    <div class={`${this.baseClass}__content`}>
                                        <div class={`${this.baseClass}__text`}>
                                            <slot name="title"></slot>
                                            <div
                                                class={`${this.baseClass}__copy`}
                                            >
                                                <slot name="copy"></slot>
                                            </div>
                                        </div>
                                        <div class={`${this.baseClass}__cta`}>
                                            <slot />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </WrapperElement>
            </Host>
        );
    }
}
